app.controller('purchaseReasonLogCtrl', function ($scope, $filter, $uibModal, urlServices, toaster) {
    $scope.filter = '';
    $scope.statusFilter = 'ALL';
    $scope.missingOnly = false;
    $scope.paginationOptions = {
        pageNumber: 1,
        pageSize: 20
    };
    $scope.datePicker = {
        startDate: moment().subtract(30, 'days'),
        endDate: moment()
    };
    $scope.dataList = {
        totalItems: 0,
        data: []
    };
    $scope.reasonCodeOptions = [];
    $scope.reasonCodeLoading = false;

    function normalizeTextValue(value) {
        return String(value === undefined || value === null ? '' : value).trim();
    }

    function normalizeError(err, fallbackMessage) {
        if (!err) {
            return fallbackMessage || 'Error tidak terdeteksi';
        }
        if (err.err) {
            return err.err;
        }
        if (err.message) {
            return err.message;
        }
        return String(err);
    }

    function buildQuery(page) {
        var query = [
            'limit=' + encodeURIComponent($scope.paginationOptions.pageSize),
            'pg=' + encodeURIComponent(page || 1),
            'start_date=' + encodeURIComponent($filter('date')($scope.datePicker.startDate._d || $scope.datePicker.startDate, 'yyyy-MM-dd')),
            'end_date=' + encodeURIComponent($filter('date')($scope.datePicker.endDate._d || $scope.datePicker.endDate, 'yyyy-MM-dd')),
            'status=' + encodeURIComponent($scope.statusFilter || 'ALL')
        ];

        if ($scope.filter) {
            query.push('term=' + encodeURIComponent($scope.filter));
        }
        if ($scope.missingOnly) {
            query.push('missing_only=1');
        }

        return query.join('&');
    }

    function loadReasonCodes(callback) {
        if ($scope.reasonCodeOptions.length > 0) {
            return callback(null, $scope.reasonCodeOptions);
        }

        $scope.reasonCodeLoading = true;
        return urlServices.ambilData('api/purchase-reason-codes', {}, function (err, result) {
            $scope.reasonCodeLoading = false;
            if (err) {
                return callback(normalizeError(err, 'Master reason code tidak dapat dimuat'));
            }
            $scope.reasonCodeOptions = (result || []).filter(function (item) {
                return item && item.reasonCode;
            });
            return callback(null, $scope.reasonCodeOptions);
        });
    }

    $scope.hasReason = function (row) {
        return !!(normalizeTextValue(row && row.reasonCode) && normalizeTextValue(row && row.reasonDetail));
    };

    $scope.getActionLabel = function (row) {
        return $scope.hasReason(row) ? 'Edit' : 'Isi';
    };

    $scope.viewData = function (page) {
        $scope.paginationOptions.pageNumber = page || 1;
        return urlServices.ambilData('api/purchase-reason-log?' + buildQuery($scope.paginationOptions.pageNumber), {}, function (err, result) {
            if (err) {
                $scope.dataList.totalItems = 0;
                $scope.dataList.data = [];
                return toaster.pop('error', 'Purchase Reason', normalizeError(err, 'Gagal memuat log reason purchase'));
            }

            $scope.dataList.totalItems = result && result.records ? result.records : 0;
            $scope.dataList.data = result && result.data ? result.data : [];
        });
    };

    $scope.tampilkan = function () {
        $scope.viewData(1);
    };

    $scope.resetFilter = function () {
        $scope.filter = '';
        $scope.statusFilter = 'ALL';
        $scope.missingOnly = false;
        $scope.datePicker = {
            startDate: moment().subtract(30, 'days'),
            endDate: moment()
        };
        $scope.viewData(1);
    };

    $scope.openReasonEditor = function (row) {
        return loadReasonCodes(function (err) {
            if (err) {
                return toaster.pop('error', 'Purchase Reason', err);
            }

            return $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'modal.purchase-reason-entry.html',
                controller: 'modalPurchaseReasonEntryCtrl',
                size: 'md',
                resolve: {
                    params: function () {
                        return {
                            title: ($scope.hasReason(row) ? 'Edit' : 'Isi') + ' Reason PO',
                            row: angular.copy(row),
                            reasonCodes: $scope.reasonCodeOptions
                        };
                    }
                }
            }).result.then(function (payload) {
                return urlServices.simpanData('api/purchase-reason-entry', payload, function (saveErr) {
                    if (saveErr) {
                        return toaster.pop('error', 'Purchase Reason', normalizeError(saveErr, 'Gagal menyimpan reason PO'));
                    }
                    toaster.pop('success', 'Purchase Reason', 'Reason PO berhasil disimpan');
                    return $scope.viewData($scope.paginationOptions.pageNumber);
                });
            });
        });
    };

    loadReasonCodes(function () {
        return true;
    });
    $scope.viewData(1);
});